import { createContext, useContext, useState } from "react";

type Product = {
  product: string | null;
  setProduct: (product: string | null) => void;
};

const ProductContext = createContext<Product | null>(null);

const ProductProvider = ({ children }: { children: React.ReactNode }) => {
  const [product, setProduct] = useState<string | null>(null);

  return (
    <ProductContext.Provider value={{ product, setProduct }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;

export function useCurrentProduct() {
  const context = useContext(ProductContext);

  if (!context) {
    throw new Error(
      "useCurrentProduct deve ser usado dentro de ProductProvider",
    );
  }

  return context;
}
